import KizenTypography from 'app/kizentypo';

export const LinkButton = ({ route, text, replace }) => {
  return (
    <KizenTypography
      className="link_button"
      type="link"
      color="blue"
      to={route}
      replace={replace}
    >
      {text}
    </KizenTypography>
  );
};
